/**
 * Accepts time in 24hr format and returns string time format like 01:00pm or 13:00
 * @param input
 * @param uses24hr
 * @constructor
 */
const transform24hrTimeToString = (input, uses24hr) => {
  const pattern = new RegExp('^\\d?\\d:?\\d?\\d?\\s*$');
  if (input && !pattern.test(input.trim())) {
    return input;
  }

  const hours = input.split(':')[0];
  const minutes = input.split(':')[1];

  if (uses24hr) {
    return `${hours}:${minutes.length === 1 ? `0${minutes}` : minutes}`;
  }

  if (parseInt(hours, 10) === 0) {
    return `12:${minutes.length === 1 ? `0${minutes}` : minutes} AM`;
  }

  if (parseInt(hours, 10) === 12) {
    return `12:${minutes.length === 1 ? `0${minutes}` : minutes} PM`;
  }

  if (parseInt(hours, 10) > 12) {
    const newHours = parseInt(hours, 10) - 12;
    return `${newHours}:${minutes.length === 1 ? `0${minutes}` : minutes} PM`;
  }

  return `${parseInt(hours, 10)}:${
    minutes.length === 1 ? `0${minutes}` : minutes
  } AM`;
};

export { transform24hrTimeToString };
